import React from "react";
import { Alert, Box, Stack, Typography } from "@mui/material";
import MergeTypeOutlined from "@mui/icons-material/MergeTypeOutlined";

const DISMISS_KEY = "video-stitch-intro-dismissed";

export default function VideoProjectIntro({ lang }) {
  const [dismissed, setDismissed] = React.useState(() => {
    try {
      return localStorage.getItem(DISMISS_KEY) === "1";
    } catch {
      return false;
    }
  });

  if (dismissed) return null;

  return (
    <Alert
      severity="info"
      icon={<MergeTypeOutlined />}
      onClose={() => {
        setDismissed(true);
        try {
          localStorage.setItem(DISMISS_KEY, "1");
        } catch {
          // ignore
        }
      }}
      sx={{ mb: 2, borderRadius: 2 }}
    >
      <Typography variant="subtitle2" fontWeight={900} gutterBottom>
        {lang?.videoStitchIntroTitle || "Clip board — join clips into one"}
      </Typography>
      <Stack component="ol" spacing={0.5} sx={{ m: 0, pl: 2.5 }}>
        <Typography component="li" variant="body2">
          {lang?.videoStitchIntroStep1 || 'Use the bottom tray: click "+" Add to pick videos from your library.'}
        </Typography>
        <Typography component="li" variant="body2">
          {lang?.videoStitchIntroStep2 || "Select multiple completed videos, then Add selected."}
        </Typography>
        <Typography component="li" variant="body2">
          {lang?.videoStitchIntroStep3 || "Drag clips to reorder, then Join videos when you have 2 or more."}
        </Typography>
      </Stack>
      <Box sx={{ mt: 1 }}>
        <Typography variant="caption" color="text.secondary" fontWeight={600}>
          {lang?.videoStitchIntroWhere || "Clip board is fixed at the bottom of Video Studio."}
        </Typography>
      </Box>
    </Alert>
  );
}
